module.exports = __webpack_public_path__ + "img/pc-list-one-cart.9f86b599.jpg";